


































































import {Component, Vue} from 'vue-property-decorator';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import {Action, Getter} from 'vuex-class';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import {answersApi} from '../services/answers';
import { AnswerListItemViewModel } from '../models/answers/answerListItemViewModel';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import Toast from '@/shared/services/toast';
import ConfirmationModal from '@/shared/components/ConfirmationModal.vue';
import { LOAD_ANSWERS } from '@/store/answers/actionTypes';
import HtmlFormatter from '@/shared/services/htmlFormatter';
import AddAnswerModal from '@/features/bots/components/AddAnswerModal.vue';

@Component({
	components: {
		LoadingSpinner,
		DropDownMenu,
		DeleteIcon,
		AddAnswerModal,
		ConfirmationModal
	}
})
export default class Answers extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Getter public isWorkspaceFeatureEnabled!: (key: string) => boolean;
	@Action(LOAD_ANSWERS) public loadAnswers: any;

	public answers: AnswerListItemViewModel[] = [];
	public loading: boolean = true;

	public showCreateModal: boolean = false;
	public showDeleteModal: boolean = false;
	public answerToDelete: AnswerListItemViewModel;


	public async mounted() {
		await this.getAnswers();
		this.loading = false;
	}

	public addAnswer() {
		this.showCreateModal = true;
	}

	public editAnswer(answer: AnswerListItemViewModel, created = false) {
		this.$router.push({name: 'bots-answer-editor', params: {id: answer.id}, query: { created: created.toString() }});
	}

	public deleteAnswer(answer: AnswerListItemViewModel) {
		this.answerToDelete = answer;
		this.showDeleteModal = true;
	}

	public async deleteAnswerConfirm() {
		this.showDeleteModal = false;
		try {
			await answersApi.deleteAnswer(this.currentWorkspace.id, this.answerToDelete.id);
			this.answers = this.answers.filter(answer => answer.id !== this.answerToDelete.id);
			Toast.showSuccess('Deleted FAQ');
		} catch (ex) {
			Toast.showError('Failed to delete FAQ : ' + ex.message);
		}
	}

	public getDeleteAnswerConfirmationMessage() {
		return `Are you sure you want to delete the <b>${HtmlFormatter.escapeHtmlCharacters(this.answerToDelete.title)}</b> FAQ? The action is irreversible. Please type the name of the FAQ to confirm:`;
	}

	private async getAnswers() {
		this.answers = await this.loadAnswers(true);
	}
}
